export const translations = {
  en: {
    header: {
      title: 'AI Kitchen Chef',
    },
    hero: {
      title: 'Transform Your Ingredients Into Amazing Recipes',
      subtitle: 'Simply take a photo of your ingredients and let AI create personalized recipes just for you. No more wondering what to cook with what you have in your fridge!',
      description: 'AI Kitchen Chef revolutionizes the way you cook by using advanced artificial intelligence to analyze your ingredients and suggest the perfect recipes. Whether you have a few vegetables, some meat, or random items in your pantry, our AI will help you create delicious meals in minutes.',
      cta: 'Get Started Free',
      secondaryCta: 'Learn More',
    },
    features: {
      title: 'Why Choose AI Kitchen Chef?',
      subtitle: 'Discover the power of AI-driven cooking assistance',
      feature1: {
        title: 'Smart Recognition',
        description: 'Our advanced AI technology can identify hundreds of ingredients from a single photo. From fresh vegetables to packaged goods, nothing escapes our intelligent recognition system.',
        details: 'Using state-of-the-art computer vision and machine learning algorithms, we can accurately identify ingredients even in challenging lighting conditions or when items are partially obscured.',
      },
      feature2: {
        title: 'Personalized Recipes',
        description: 'Get recipes tailored specifically to your available ingredients, dietary preferences, and cooking skill level. Our AI considers your allergies, dietary restrictions, and favorite cuisines.',
        details: 'Every recipe suggestion is customized based on what you have, how much time you have, and what you enjoy eating. No more searching through cookbooks or websites for hours.',
      },
      feature3: {
        title: 'Easy to Use',
        description: 'Just snap a photo and get instant recipe suggestions. Our intuitive interface makes cooking accessible to everyone, from beginners to professional chefs.',
        details: 'The app is designed with simplicity in mind. No complicated menus or confusing options. Just point, shoot, and cook. It\'s that simple.',
      },
      feature4: {
        title: 'Recipe Variations',
        description: 'Get multiple recipe options for the same ingredients. Want something quick? Healthy? Traditional? Our AI provides various options to suit your mood and needs.',
        details: 'Each ingredient combination can generate dozens of recipe variations, from quick 15-minute meals to elaborate dishes that impress guests.',
      },
      feature5: {
        title: 'Nutritional Information',
        description: 'Every recipe comes with detailed nutritional information, helping you make informed choices about your meals and maintain a balanced diet.',
        details: 'Track calories, macronutrients, vitamins, and minerals for every dish. Perfect for those managing their health or following specific dietary plans.',
      },
      feature6: {
        title: 'Save & Share',
        description: 'Save your favorite recipes and share them with friends and family. Build your personal recipe collection and never lose a great recipe again.',
        details: 'Create custom recipe collections, add notes, and share your culinary discoveries with a community of food lovers worldwide.',
      },
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Three simple steps to amazing meals',
      step1: {
        title: 'Take a Photo',
        description: 'Open the app and take a clear photo of your ingredients. You can photograph them on your counter, in your fridge, or even while shopping at the store.',
        details: 'Our AI works best with good lighting and clear images, but don\'t worry - it\'s smart enough to handle most real-world situations.',
      },
      step2: {
        title: 'AI Analysis',
        description: 'Our powerful AI analyzes your photo in seconds, identifying all ingredients and their quantities. The system recognizes fresh produce, packaged goods, spices, and more.',
        details: 'Using advanced machine learning models trained on millions of food images, our AI can identify ingredients with remarkable accuracy, even when they\'re partially visible or in unusual arrangements.',
      },
      step3: {
        title: 'Get Recipes',
        description: 'Receive personalized recipe suggestions ranked by relevance, difficulty, and cooking time. Each recipe includes step-by-step instructions, ingredient lists, and cooking tips.',
        details: 'Filter recipes by cuisine type, cooking time, dietary requirements, or difficulty level. Find the perfect recipe for any occasion, from quick weekday dinners to special occasion feasts.',
      },
    },
    benefits: {
      title: 'Benefits of Using AI Kitchen Chef',
      subtitle: 'Experience the future of cooking',
      benefit1: {
        title: 'Reduce Food Waste',
        description: 'Use up ingredients before they go bad. Our AI helps you find recipes for items you might otherwise throw away, saving money and reducing waste.',
      },
      benefit2: {
        title: 'Save Time',
        description: 'No more endless scrolling through recipe websites. Get instant suggestions based on what you actually have, not what you need to buy.',
      },
      benefit3: {
        title: 'Discover New Flavors',
        description: 'Break out of your cooking rut. Our AI suggests combinations and recipes you might never have thought of, expanding your culinary horizons.',
      },
      benefit4: {
        title: 'Learn to Cook',
        description: 'Perfect for beginners! Get detailed instructions and tips that help you improve your cooking skills while creating delicious meals.',
      },
    },
    cta: {
      title: 'Ready to Start Cooking?',
      subtitle: 'Join thousands of users creating amazing meals with AI Kitchen Chef. Start your culinary journey today!',
      description: 'Start your culinary journey now and transform the way you cook. No credit card required. Start free and upgrade anytime.',
      button: 'Start Cooking Now',
      secondaryButton: 'Download App',
    },
    footer: {
      terms: 'I have read and agree to the Terms of Service.',
      adult: 'Service for adults. To cancel subscription send SMS (COST 0 PLN) SAIF to 80711 (PLUS, Orange) 80713 (T-MOBILE).',
      organizer: 'Organizer: Aminta B.V Nassaukade 157H 1053 LK Amsterdam. Complaints: tel (9-17) 22 244 40 22 or reklamacje@teleaudio.pl.',
    },
  },
  pl: {
    header: {
      title: 'AI Kitchen Chef',
    },
    hero: {
      title: 'Przekształć Swoje Składniki W Niesamowite Przepisy',
      subtitle: 'Po prostu zrób zdjęcie swoich składników i pozwól AI stworzyć spersonalizowane przepisy specjalnie dla Ciebie. Koniec z zastanawianiem się, co ugotować z tego, co masz w lodówce!',
      description: 'AI Kitchen Chef rewolucjonizuje sposób, w jaki gotujesz, wykorzystując zaawansowaną sztuczną inteligencję do analizy Twoich składników i sugerowania idealnych przepisów. Niezależnie od tego, czy masz kilka warzyw, trochę mięsa czy losowe produkty w spiżarni, nasze AI pomoże Ci stworzyć pyszne posiłki w ciągu minut.',
      cta: 'Zacznij Za Darmo',
      secondaryCta: 'Dowiedz Się Więcej',
    },
    features: {
      title: 'Dlaczego Wybrać AI Kitchen Chef?',
      subtitle: 'Odkryj moc asystenta kulinarnego napędzanego przez AI',
      feature1: {
        title: 'Inteligentne Rozpoznawanie',
        description: 'Nasza zaawansowana technologia AI może zidentyfikować setki składników z jednego zdjęcia. Od świeżych warzyw po produkty pakowane, nic nie ucieka przed naszym inteligentnym systemem rozpoznawania.',
        details: 'Używając najnowocześniejszych algorytmów widzenia komputerowego i uczenia maszynowego, możemy dokładnie zidentyfikować składniki nawet w trudnych warunkach oświetleniowych lub gdy przedmioty są częściowo zasłonięte.',
      },
      feature2: {
        title: 'Spersonalizowane Przepisy',
        description: 'Otrzymuj przepisy dopasowane specjalnie do Twoich dostępnych składników, preferencji żywieniowych i poziomu umiejętności kulinarnych. Nasze AI uwzględnia Twoje alergie, ograniczenia dietetyczne i ulubione kuchnie.',
        details: 'Każda sugestia przepisu jest dostosowana na podstawie tego, co masz, ile masz czasu i co lubisz jeść. Koniec z godzinami przeszukiwania książek kucharskich lub stron internetowych.',
      },
      feature3: {
        title: 'Łatwe W Użyciu',
        description: 'Po prostu zrób zdjęcie i otrzymaj natychmiastowe sugestie przepisów. Nasz intuicyjny interfejs sprawia, że gotowanie jest dostępne dla wszystkich, od początkujących po profesjonalnych kucharzy.',
        details: 'Aplikacja została zaprojektowana z myślą o prostocie. Żadnych skomplikowanych menu czy mylących opcji. Po prostu wyceluj, zrób zdjęcie i gotuj. To takie proste.',
      },
      feature4: {
        title: 'Warianty Przepisów',
        description: 'Otrzymuj wiele opcji przepisów dla tych samych składników. Chcesz coś szybkiego? Zdrowego? Tradycyjnego? Nasze AI zapewnia różne opcje dopasowane do Twojego nastroju i potrzeb.',
        details: 'Każda kombinacja składników może wygenerować dziesiątki wariantów przepisów, od szybkich 15-minutowych posiłków po wyszukane dania, które zaimponują gościom.',
      },
      feature5: {
        title: 'Informacje Żywieniowe',
        description: 'Każdy przepis zawiera szczegółowe informacje żywieniowe, pomagając Ci podejmować świadome wybory dotyczące posiłków i utrzymywać zbilansowaną dietę.',
        details: 'Śledź kalorie, makroskładniki, witaminy i minerały dla każdego dania. Idealne dla osób zarządzających swoim zdrowiem lub stosujących określone plany żywieniowe.',
      },
      feature6: {
        title: 'Zapisz i Udostępnij',
        description: 'Zapisuj swoje ulubione przepisy i udostępniaj je przyjaciołom i rodzinie. Twórz swoją osobistą kolekcję przepisów i nigdy więcej nie trać świetnego przepisu.',
        details: 'Twórz niestandardowe kolekcje przepisów, dodawaj notatki i dziel się swoimi odkryciami kulinarnymi ze społecznością miłośników jedzenia na całym świecie.',
      },
    },
    howItWorks: {
      title: 'Jak To Działa',
      subtitle: 'Trzy proste kroki do niesamowitych posiłków',
      step1: {
        title: 'Zrób Zdjęcie',
        description: 'Otwórz aplikację i zrób wyraźne zdjęcie swoich składników. Możesz je sfotografować na blacie, w lodówce, a nawet podczas zakupów w sklepie.',
        details: 'Nasze AI działa najlepiej przy dobrym oświetleniu i wyraźnych obrazach, ale nie martw się - jest wystarczająco inteligentne, aby poradzić sobie z większością rzeczywistych sytuacji.',
      },
      step2: {
        title: 'Analiza AI',
        description: 'Nasze potężne AI analizuje Twoje zdjęcie w ciągu sekund, identyfikując wszystkie składniki i ich ilości. System rozpoznaje świeże produkty, produkty pakowane, przyprawy i więcej.',
        details: 'Używając zaawansowanych modeli uczenia maszynowego szkolonych na milionach obrazów żywności, nasze AI może zidentyfikować składniki z niezwykłą dokładnością, nawet gdy są częściowo widoczne lub w nietypowych układach.',
      },
      step3: {
        title: 'Otrzymaj Przepisy',
        description: 'Otrzymuj spersonalizowane sugestie przepisów uszeregowane według trafności, trudności i czasu gotowania. Każdy przepis zawiera instrukcje krok po kroku, listy składników i wskazówki kulinarne.',
        details: 'Filtruj przepisy według typu kuchni, czasu gotowania, wymagań dietetycznych lub poziomu trudności. Znajdź idealny przepis na każdą okazję, od szybkich kolacji w dni powszednie po uczty na specjalne okazje.',
      },
    },
    benefits: {
      title: 'Korzyści Z Używania AI Kitchen Chef',
      subtitle: 'Doświadcz przyszłości gotowania',
      benefit1: {
        title: 'Zmniejsz Marnowanie Żywności',
        description: 'Wykorzystaj składniki, zanim się zepsują. Nasze AI pomaga znaleźć przepisy na produkty, które w przeciwnym razie mogłyby zostać wyrzucone, oszczędzając pieniądze i zmniejszając marnotrawstwo.',
      },
      benefit2: {
        title: 'Oszczędzaj Czas',
        description: 'Koniec z niekończącym się przewijaniem stron z przepisami. Otrzymuj natychmiastowe sugestie na podstawie tego, co faktycznie masz, a nie tego, co musisz kupić.',
      },
      benefit3: {
        title: 'Odkryj Nowe Smaki',
        description: 'Wyjdź ze swojej kulinarnej rutyny. Nasze AI sugeruje kombinacje i przepisy, o których mogłeś nigdy nie pomyśleć, poszerzając Twoje kulinarne horyzonty.',
      },
      benefit4: {
        title: 'Naucz Się Gotować',
        description: 'Idealne dla początkujących! Otrzymuj szczegółowe instrukcje i wskazówki, które pomagają poprawić Twoje umiejętności kulinarne podczas tworzenia pysznych posiłków.',
      },
    },
    cta: {
      title: 'Gotowy, Aby Zacząć Gotować?',
      subtitle: 'Dołącz do tysięcy użytkowników tworzących niesamowite posiłki z AI Kitchen Chef. Rozpocznij swoją kulinarną podróż już dziś!',
      description: 'Rozpocznij swoją kulinarną podróż już teraz i przekształć sposób, w jaki gotujesz. Karta kredytowa nie jest wymagana. Zacznij za darmo i ulepszaj w dowolnym momencie.',
      button: 'Zacznij Gotować Teraz',
      secondaryButton: 'Pobierz Aplikację',
    },
    footer: {
      terms: 'Zapoznałem się z treścią regulaminu Usługi Dostępowej.',
      adult: 'Serwis dla osób pełnoletnich, aby zrezygnować z subskrypcji wyślij SMS ( KOSZT 0 zł ) SAIF na 80711 ( PLUS , Orange ) 80713 ( T-MOBILE ).',
      organizer: 'Organizator: Aminta B.V Nassaukade 157H 1053 LK Amsterdam. Reklamacje: tel (9-17) 22 244 40 22 lub reklamacje@teleaudio.pl.',
    },
  },
};
